module.exports = __webpack_public_path__ + "img/returns-color.ebadf7e2.svg";